<template>
  <div v-if="experiment" :class="'template-' + experiment.template_id">
    <p v-if="experiment.status === '1'">DRAFT</p>
    <screen :screen="screens[progress]" @hook:mounted="checkOrientation()"></screen>
  </div>
</template>

<script>
import Screen from './Screen'
var md5 = require('md5')

export default {
  name: 'Poll',
  components: {
    Screen
  },
  data() {
    return {
      experiment: null,
      screens: [],
      session: '',
      progress: 0,
      clickOrder: 1,
      screenTimeStart: +new Date(),
      variables: {},
      lockSize: false,
      isMobile: false,
      diagData: [{}]
    }
  },
  created() {
    this.load();
  },
  mounted() {
    this.mobileCheck();
    window.onresize = () => {
        this.checkOrientation();
    }
  },
  methods: {
    async load() {
      let self = this;
      let query = btoa(JSON.stringify(this.$route.query));
      try {
        this.showSpinner();
        const response = await fetch(this.$root.apiUrl + 'v1/pollster/experiments/' + this.$route.params.id + '?bySlug=true&query=' + query);
        var responseObj = await response.json();
        if (response.status === 200 && responseObj.response) {
          var responseCore = responseObj.response;
          if (!responseCore.experiment.code) {
            self.$router.push({name: 'Error', params: {message: 'No data to show'}})
          }
          if (responseCore.experiment.status === '1') self.$router.push({name: 'PageNotFound'})
          if (responseCore.experiment.status === '4') {
            var parsedCode = JSON.parse(responseCore.experiment.code)
            if(parsedCode.hasOwnProperty('messages') && parsedCode.messages.hasOwnProperty('surveyIsClosed')) {
              self.$router.push({name: 'Error', params: {message: parsedCode.messages.surveyIsClosed, css: parsedCode.style}})
            } else {
              self.$router.push({name: 'Error', params: {message: 'Survey is closed'}})
            }
          }
          self.experiment = responseCore.experiment
          self.experiment.crn = responseCore.crn
          self.prepareCode(self.experiment.code)

          let date = new Date();
          let dateString = (date.getFullYear()).toString() +
            ("0"+(date.getUTCMonth()+1).toString()).slice(-2) +
            ("0"+(date.getUTCDate()).toString()).slice(-2) +
            ("0"+(date.getUTCHours()).toString()).slice(-2) +
            ("0"+(date.getUTCMinutes()).toString()).slice(-2) +
            ("0"+(date.getUTCSeconds()).toString()).slice(-2) +
            ("00"+(date.getUTCMilliseconds()).toString()).slice(-3);
          let random = Math.random() * 1000000;
          let floor = Math.floor(random);
          let md5String = md5(floor);
          this.session = dateString.concat(md5String).substring(0,32);

          try {
            localStorage.setItem('session', this.session)
          }
          catch(e) {
            self.$router.push({
              name: 'BlockedCookies',
              params: {
                previousLink: window.location.href
              }
            });
          }
          localStorage.removeItem('results')
        } else if (response.status === 403) {
          self.$router.push({name: 'Error', params: {message: 'Blocked link'}})
        } else if (response.status === 404) {
          self.$router.push({name: 'PageNotFound'})
        } else {
          var message
          if (responseObj.response && responseObj.response[0] && responseObj.response[0].message) {
            message = responseObj.response[0].message
          } else {
            message = 'Unknown error'
          }
          self.$router.push({name: 'Error', params: {message: message}})
        }
      } catch (error) {
        console.error(error.message);
      } finally {
        this.hideSpinner();
      }
    },
    mobileCheck() {
        var self = this;
        // https://stackoverflow.com/questions/11381673/detecting-a-mobile-browser
        (function (a) {
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0,4))) self.isMobile = true;
        })(navigator.userAgent || navigator.vendor || window.opera);

        var htmlTag = document.getElementsByTagName("html")[0];
        if (this.isMobile) {
            htmlTag.classList.add("isMobile");
        } else {
            htmlTag.classList.add("isDesktop");
        }
    },
    checkOrientation() {
        var orientation = window.innerWidth > window.innerHeight ? "landscape" : "portrait";
        var screenContent = document.getElementsByClassName("screen-content")[0];
        screenContent.classList.remove("landscape");
        screenContent.classList.remove("portrait");
        screenContent.classList.add(orientation);

        if (!this.lockSize) {
            var vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty("--vh", vh + "px");
        }

        if (orientation === "landscape" && this.isMobile) {
            this.lockSize = true;
            document.body.style.backgroundColor = "#fff";
        }
    },
    go(skip) {
      if(skip === null || typeof skip === 'undefined') skip = 0
      this.screenTimeStart = +new Date()
      //diagData
      this.diagData[this.diagData.length -1].session = this.session ;
      this.diagData[this.diagData.length -1].clickOrder = this.clickOrder ;
      this.diagData[this.diagData.length -1].skip = skip ;
      this.diagData[this.diagData.length -1].screenTimeStart = this.screenTimeStart ;
      this.diagData[this.diagData.length -1].screensNumber = this.screens.length ;
      if (this.progress == 0) {
        this.diagData[this.diagData.length -1].variables = this.variables;
        this.diagData[this.diagData.length -1].screens = this.getScreensDiagData();
      }
      this.progress = this.progress + 1 + skip
      this.diagData[this.diagData.length -1].progress = this.progress;
      this.diagData[this.diagData.length -1].stackTrace = this.getStackTrace();
      this.diagData.push({});
    },
    prepareCode(code) {
      code = JSON.parse(code)
      let self = this
      let preparedScreens = []

      document.onkeydown = function (t) {
        if (
          Number(t.which) === 9 ||
          Number(t.keyCode) === 9 ||
          t.code.toLowerCase() === "tab" ||
          t.key.toLowerCase() === "tab"
        ) {
          return false;
        }
      };

      code.sections.forEach((section, secIndex) => {
        section.screens.forEach((screen, scrIndex) => {
          code.sections[secIndex].screens[scrIndex].sectionNum = secIndex + 1
          code.sections[secIndex].screens[scrIndex].sectionName = section.name
        })
      })

      if(code.groups && code.groups.length > 0) {
        // POGRUPOWANIE SEKCJI PO GRUPACH
        let codeSectionsTemp = JSON.parse(JSON.stringify(code.sections))
        let sectionsOrder = []
        let groupOrder = []

        // w pętli dodajemy do sekcji informacje o grupach
        codeSectionsTemp.forEach((s, si) => {
          let group = null
          let shuffleSections = null
          code.groups.forEach((g, gi) => {
            g.sections.forEach((gs, gsi) => {
              if(gs.selected === true && gsi === si) {
                group = gi
                shuffleSections = g.shuffleSections
              }
            })
          })
          s.group = group
          s.shuffleSections = shuffleSections
          sectionsOrder.push(s)
        })

        let virtualGroupsIndexes = []
        let virtualGroupsCount = 0
        let groupIndex = -1
        sectionsOrder.forEach((so, soi) => {
          let virtual = false
          // jeżeli wolna sekcja to tworzymy wirtualną grupę
          if(so.group === null) {
            virtual = true
            groupIndex++
            if(!groupOrder[groupIndex]) {
              groupOrder[groupIndex] = {
                sections: []
              }
            }
            groupOrder[groupIndex].sections.push(so)
            // tworzymy listę wirtualnych grup, żeby je tymczasowo usunąć podczas rotowania grup względem siebie
            virtualGroupsIndexes.push(groupIndex)
            virtualGroupsCount++
          } else {
            groupIndex = so.group + virtualGroupsCount
          if(!groupOrder[groupIndex]) {
            groupOrder[groupIndex] = {
              sections: []
            }
          }
          groupOrder[groupIndex].sections.push(so)
          }
        })
        // -----------------------------
        // console.log(groupOrder)
        // console.log(virtualGroupsIndexes)

        // MIESZANIE GRUP I SEKCJI
        // mieszanie grup
        if(code.groupsShuffle) {
          let groupOrderTemp = JSON.parse(JSON.stringify(groupOrder))
          // usuwamy tymczasowo wirtualne grupy
          if(virtualGroupsIndexes.length > 0) {
            let spliced = 0
            virtualGroupsIndexes.forEach((vg, vgi) => {
              groupOrderTemp.splice(vg - spliced, 1)
              spliced++
            })
          }
          // console.log(groupOrderTemp)
          // mieszamy
          groupOrderTemp = this.shuffle(groupOrderTemp)
          // przywracamy wirtualne grupy
          if(virtualGroupsIndexes.length > 0) {
            let groupOrderTemp2 = []
            let shuffledGroupIndex = 0
            let got = JSON.parse(JSON.stringify(groupOrderTemp))
            for(let i=0; i<groupOrder.length; i++) {
              if(virtualGroupsIndexes.indexOf(i) >= 0) {
                groupOrderTemp2.push(groupOrder[i])
              } else {
                groupOrderTemp2.push(got[shuffledGroupIndex])
                shuffledGroupIndex++
              }
            }
            groupOrderTemp = groupOrderTemp2
          }
          groupOrder = groupOrderTemp
        }
        // console.log(groupOrder)
        //mieszanie sekcji
        let groupOrderTemp3 = JSON.parse(JSON.stringify(groupOrder))
        groupOrderTemp3.forEach((got, goti) => {
          if(got.sections.length > 0 && got.sections[0].shuffleSections === true) groupOrder[goti].sections = this.shuffle(groupOrder[goti].sections)
        })
        // console.log(groupOrder)

        // przekształcenie grup na listę sekcji
        let newSections = []
        groupOrder.forEach((go, goi) => {
          go.sections.forEach(s => {
            newSections.push(s)
          })
        })
        code.sections = newSections
        // ---------------------------------
      }

      code.sections = this.shuffleScreens(code.sections)
      code.sections.forEach(section => {
        if (Array.isArray(section.screens)) {
          section.screens.forEach((screen, scrIndex) => {
            let iterations = 1
            let additionalHtml = screen.html
            let loop = null
            let sectionLoopScreens = []
            if (screen.loop) {
              let A = this
              var toEval = "(function() {" + screen.loop + "}())"
              try {
                loop = eval(toEval)
              }
              catch(e) {
                console.error('Error in loop ' + screen.name + ':')
                console.error(toEval)
                if (e instanceof SyntaxError) {
                  console.error(e.message)
                } else {
                  throw(e)
                }
              }
              if(loop.prepareData && typeof loop.prepareData === 'function') {
                loop.prepareData()
              }
              iterations = loop.iterations
            }
            for (let i = 0; i < iterations; i++) {
              let html = ''
              let scr = JSON.parse(JSON.stringify(screen))
              if (Array.isArray(screen.elements)) {
                screen.elements.forEach(element => {
                  let elementHtml = element.template
                  for (var option in element.options) {
                    if (loop && loop[element.hash] && loop[element.hash][option]) {
                      if(typeof loop[element.hash][option] === 'string') loop[element.hash][option] = this.getVar(loop[element.hash][option])
                      elementHtml = elementHtml.replace('@' + option + '@', loop[element.hash][option][i])
                    }
                    else
                      elementHtml = elementHtml.replace('@' + option + '@', element.options[option])
                  }
                  html += elementHtml + '<style>' + element.style + '</style>'
                })
                if (!additionalHtml) additionalHtml = ''
                if (!code.style) code.style = ''
                if (!section.style) section.style = ''
                if (!scr.style) scr.style = ''
                scr.html = html + additionalHtml + '<style>' + code.style + section.style + scr.style + '</style>'
                if (iterations > 1) {
                  if (loop.screenNames && typeof loop.screenNames === 'string') {
                    var names = this.getVar(loop.screenNames)
                    scr.name = names[i]
                  } else {
                    scr.name += '_' + i
                  }
                }
              }
              scr.loopIteration = i
              if (scrIndex === 0 && i === 0) {
                scr.scripts.before = section.scripts.before + ';' + scr.scripts.before
                if (section.screens.length === 1) {
                  scr.scripts.after = scr.scripts.after + ';' + section.scripts.after
                }
                sectionLoopScreens.push(scr)
              } else if (scrIndex === section.screens.length - 1) {
                scr.scripts.after = scr.scripts.after + ';' + section.scripts.after
                sectionLoopScreens.push(scr)
              } else {
                sectionLoopScreens.push(scr)
              }
            }
            // if (section.shuffleScreens === true) sectionLoopScreens = this.shuffle(sectionLoopScreens)
            sectionLoopScreens.forEach(sc => {
              preparedScreens.push(sc)
            })
          })
        }
      })
      self.screens = preparedScreens
    },
    setVar(name, value) {
      this.variables[name] = value
    },
    getVar(name) {
      return this.variables[name]
    },
    getScreens() {
      return this.screens
    },
    shuffleScreens(sections) {
      let shuffled = []
      let toShuffle = []
      let self = this
      sections.forEach((section, i) => {
        if (section.shuffleScreens === true) {
          sections[i].screens = self.shuffle(section.screens)
        }
        if (section.shuffle === true) {
          toShuffle.push(sections[i])
        }
      })
      toShuffle = this.shuffle(toShuffle)
      sections.forEach((section, i) => {
        if (section.shuffle === true) {
          shuffled.push(toShuffle.shift())
        } else {
          shuffled.push(sections[i])
        }
      })
      return shuffled
    },
    shuffle(a) {
      var j, x, i;
      for (i = a.length - 1; i > 0; i--) {
        j = Math.floor(Math.random() * (i + 1))
        x = a[i]
        a[i] = a[j]
        a[j] = x
      }
      return a
    },
    getSessionID() {
      if (this.session) {
        return this.session;
      }
      var url = new URL(window.location.href.replace('/#', ''));
      var iidPosition = url.search.indexOf("?iid=");
      var sessionId = url.search.substring(iidPosition + 5);
      if (sessionId.indexOf("&") !== -1) {
          sessionId = sessionId.substring(0, sessionId.indexOf("&"));
      }
      this.session = sessionId; // nadpisanie ID sesji tym z adresu
      return sessionId;
    },
    showSpinner() {
      if(!document.getElementById("loadingSpinner")) {
        const div = document.createElement('div');
        div.id = "loadingSpinner";
        document.body.appendChild(div);
      }
    },
    hideSpinner() {
      if(document.getElementById("loadingSpinner")) {
        document.getElementById("loadingSpinner").remove();
      }
    },

    getScreensDiagData() {
      var data = [];
      this.screens.forEach((screen) => {
        let tmp = {
            hash: screen.hash,
            loopIteration: screen.loopIteration,
            name: screen.name,
            sectionName: screen.sectionName,
            sectionNum: screen.sectionNum
        };
        data.push(tmp);
      });
      return data;
    },
    getStackTrace () {
        let stack = new Error().stack || '';
        stack = stack.split('\n').map(function (line) { return line.trim(); });
        return stack.splice(stack[0] == 'Error' ? 2 : 1);
    }
  }
}
</script>
<style>
#loadingSpinner {
    font-size: 1em;
    width: 1em;
    height: 1em;
    border-radius: 50%;
    text-indent: -9999em;
    -webkit-animation: load5 1.1s infinite ease;
    animation: load5 1.1s infinite ease;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
    position: fixed;
    z-index: 999;
    margin: auto;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
}
@-webkit-keyframes load5 {
    0%,
    100% {
        box-shadow: 0em -2.6em 0em 0em #0070c0, 1.8em -1.8em 0 0em rgba(0,112,192, 0.2), 2.5em 0em 0 0em rgba(0,112,192, 0.2), 1.75em 1.75em 0 0em rgba(0,112,192, 0.2), 0em 2.5em 0 0em rgba(0,112,192, 0.2), -1.8em 1.8em 0 0em rgba(0,112,192, 0.2), -2.6em 0em 0 0em rgba(0,112,192, 0.5), -1.8em -1.8em 0 0em rgba(0,112,192, 0.7);
    }
    12.5% {
        box-shadow: 0em -2.6em 0em 0em rgba(0,112,192, 0.7), 1.8em -1.8em 0 0em #0070c0, 2.5em 0em 0 0em rgba(0,112,192, 0.2), 1.75em 1.75em 0 0em rgba(0,112,192, 0.2), 0em 2.5em 0 0em rgba(0,112,192, 0.2), -1.8em 1.8em 0 0em rgba(0,112,192, 0.2), -2.6em 0em 0 0em rgba(0,112,192, 0.2), -1.8em -1.8em 0 0em rgba(0,112,192, 0.5);
    }
    25% {
        box-shadow: 0em -2.6em 0em 0em rgba(0,112,192, 0.5), 1.8em -1.8em 0 0em rgba(0,112,192, 0.7), 2.5em 0em 0 0em #0070c0, 1.75em 1.75em 0 0em rgba(0,112,192, 0.2), 0em 2.5em 0 0em rgba(0,112,192, 0.2), -1.8em 1.8em 0 0em rgba(0,112,192, 0.2), -2.6em 0em 0 0em rgba(0,112,192, 0.2), -1.8em -1.8em 0 0em rgba(0,112,192, 0.2);
    }
    37.5% {
        box-shadow: 0em -2.6em 0em 0em rgba(0,112,192, 0.2), 1.8em -1.8em 0 0em rgba(0,112,192, 0.5), 2.5em 0em 0 0em rgba(0,112,192, 0.7), 1.75em 1.75em 0 0em #0070c0, 0em 2.5em 0 0em rgba(0,112,192, 0.2), -1.8em 1.8em 0 0em rgba(0,112,192, 0.2), -2.6em 0em 0 0em rgba(0,112,192, 0.2), -1.8em -1.8em 0 0em rgba(0,112,192, 0.2);
    }
    50% {
        box-shadow: 0em -2.6em 0em 0em rgba(0,112,192, 0.2), 1.8em -1.8em 0 0em rgba(0,112,192, 0.2), 2.5em 0em 0 0em rgba(0,112,192, 0.5), 1.75em 1.75em 0 0em rgba(0,112,192, 0.7), 0em 2.5em 0 0em #0070c0, -1.8em 1.8em 0 0em rgba(0,112,192, 0.2), -2.6em 0em 0 0em rgba(0,112,192, 0.2), -1.8em -1.8em 0 0em rgba(0,112,192, 0.2);
    }
    62.5% {
        box-shadow: 0em -2.6em 0em 0em rgba(0,112,192, 0.2), 1.8em -1.8em 0 0em rgba(0,112,192, 0.2), 2.5em 0em 0 0em rgba(0,112,192, 0.2), 1.75em 1.75em 0 0em rgba(0,112,192, 0.5), 0em 2.5em 0 0em rgba(0,112,192, 0.7), -1.8em 1.8em 0 0em #0070c0, -2.6em 0em 0 0em rgba(0,112,192, 0.2), -1.8em -1.8em 0 0em rgba(0,112,192, 0.2);
    }
    75% {
        box-shadow: 0em -2.6em 0em 0em rgba(0,112,192, 0.2), 1.8em -1.8em 0 0em rgba(0,112,192, 0.2), 2.5em 0em 0 0em rgba(0,112,192, 0.2), 1.75em 1.75em 0 0em rgba(0,112,192, 0.2), 0em 2.5em 0 0em rgba(0,112,192, 0.5), -1.8em 1.8em 0 0em rgba(0,112,192, 0.7), -2.6em 0em 0 0em #0070c0, -1.8em -1.8em 0 0em rgba(0,112,192, 0.2);
    }
    87.5% {
        box-shadow: 0em -2.6em 0em 0em rgba(0,112,192, 0.2), 1.8em -1.8em 0 0em rgba(0,112,192, 0.2), 2.5em 0em 0 0em rgba(0,112,192, 0.2), 1.75em 1.75em 0 0em rgba(0,112,192, 0.2), 0em 2.5em 0 0em rgba(0,112,192, 0.2), -1.8em 1.8em 0 0em rgba(0,112,192, 0.5), -2.6em 0em 0 0em rgba(0,112,192, 0.7), -1.8em -1.8em 0 0em #0070c0;
    }
}
@keyframes load5 {
    0%,
    100% {
        box-shadow: 0em -2.6em 0em 0em #0070c0, 1.8em -1.8em 0 0em rgba(0,112,192, 0.2), 2.5em 0em 0 0em rgba(0,112,192, 0.2), 1.75em 1.75em 0 0em rgba(0,112,192, 0.2), 0em 2.5em 0 0em rgba(0,112,192, 0.2), -1.8em 1.8em 0 0em rgba(0,112,192, 0.2), -2.6em 0em 0 0em rgba(0,112,192, 0.5), -1.8em -1.8em 0 0em rgba(0,112,192, 0.7);
    }
    12.5% {
        box-shadow: 0em -2.6em 0em 0em rgba(0,112,192, 0.7), 1.8em -1.8em 0 0em #0070c0, 2.5em 0em 0 0em rgba(0,112,192, 0.2), 1.75em 1.75em 0 0em rgba(0,112,192, 0.2), 0em 2.5em 0 0em rgba(0,112,192, 0.2), -1.8em 1.8em 0 0em rgba(0,112,192, 0.2), -2.6em 0em 0 0em rgba(0,112,192, 0.2), -1.8em -1.8em 0 0em rgba(0,112,192, 0.5);
    }
    25% {
        box-shadow: 0em -2.6em 0em 0em rgba(0,112,192, 0.5), 1.8em -1.8em 0 0em rgba(0,112,192, 0.7), 2.5em 0em 0 0em #0070c0, 1.75em 1.75em 0 0em rgba(0,112,192, 0.2), 0em 2.5em 0 0em rgba(0,112,192, 0.2), -1.8em 1.8em 0 0em rgba(0,112,192, 0.2), -2.6em 0em 0 0em rgba(0,112,192, 0.2), -1.8em -1.8em 0 0em rgba(0,112,192, 0.2);
    }
    37.5% {
        box-shadow: 0em -2.6em 0em 0em rgba(0,112,192, 0.2), 1.8em -1.8em 0 0em rgba(0,112,192, 0.5), 2.5em 0em 0 0em rgba(0,112,192, 0.7), 1.75em 1.75em 0 0em #0070c0, 0em 2.5em 0 0em rgba(0,112,192, 0.2), -1.8em 1.8em 0 0em rgba(0,112,192, 0.2), -2.6em 0em 0 0em rgba(0,112,192, 0.2), -1.8em -1.8em 0 0em rgba(0,112,192, 0.2);
    }
    50% {
        box-shadow: 0em -2.6em 0em 0em rgba(0,112,192, 0.2), 1.8em -1.8em 0 0em rgba(0,112,192, 0.2), 2.5em 0em 0 0em rgba(0,112,192, 0.5), 1.75em 1.75em 0 0em rgba(0,112,192, 0.7), 0em 2.5em 0 0em #0070c0, -1.8em 1.8em 0 0em rgba(0,112,192, 0.2), -2.6em 0em 0 0em rgba(0,112,192, 0.2), -1.8em -1.8em 0 0em rgba(0,112,192, 0.2);
    }
    62.5% {
        box-shadow: 0em -2.6em 0em 0em rgba(0,112,192, 0.2), 1.8em -1.8em 0 0em rgba(0,112,192, 0.2), 2.5em 0em 0 0em rgba(0,112,192, 0.2), 1.75em 1.75em 0 0em rgba(0,112,192, 0.5), 0em 2.5em 0 0em rgba(0,112,192, 0.7), -1.8em 1.8em 0 0em #0070c0, -2.6em 0em 0 0em rgba(0,112,192, 0.2), -1.8em -1.8em 0 0em rgba(0,112,192, 0.2);
    }
    75% {
        box-shadow: 0em -2.6em 0em 0em rgba(0,112,192, 0.2), 1.8em -1.8em 0 0em rgba(0,112,192, 0.2), 2.5em 0em 0 0em rgba(0,112,192, 0.2), 1.75em 1.75em 0 0em rgba(0,112,192, 0.2), 0em 2.5em 0 0em rgba(0,112,192, 0.5), -1.8em 1.8em 0 0em rgba(0,112,192, 0.7), -2.6em 0em 0 0em #0070c0, -1.8em -1.8em 0 0em rgba(0,112,192, 0.2);
    }
    87.5% {
        box-shadow: 0em -2.6em 0em 0em rgba(0,112,192, 0.2), 1.8em -1.8em 0 0em rgba(0,112,192, 0.2), 2.5em 0em 0 0em rgba(0,112,192, 0.2), 1.75em 1.75em 0 0em rgba(0,112,192, 0.2), 0em 2.5em 0 0em rgba(0,112,192, 0.2), -1.8em 1.8em 0 0em rgba(0,112,192, 0.5), -2.6em 0em 0 0em rgba(0,112,192, 0.7), -1.8em -1.8em 0 0em #0070c0;
    }
}
</style>
